var _style, _defs, _clipPath, _g, _radialGradient, _g2, _radialGradient2, _path, _radialGradient3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "1 1 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{clip-path:url(#C)}.C{fill:#3e2723}.D{fill-opacity:.15}.E{fill-opacity:.2}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "A",
    cx: 96,
    cy: 96,
    r: 88
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "B",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 29.34,
    x2: 81.84,
    y1: 75.02,
    y2: 44.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 115.6L22.48 47.3l-.58 1 39.54 67.8z",
    className: "C D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 110.9,
    x2: 52.54,
    y1: 164.5,
    y2: 130.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: 0.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8 117.3l-.83-.48-38.4 67.15h1.15l38.1-66.64z",
    fill: "#263238",
    className: "D"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 121.9,
    x2: 136.6,
    y1: 49.8,
    y2: 114.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0.3,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#H)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#D)"
  })))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 668.2,
    cy: 55.95,
    r: 84.08,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56v20.95L174.4 56z",
    fill: "url(#K)",
    className: "B"
  }), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#E)"
  }))))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 597.9,
    cy: 48.52,
    r: 78.04,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7 -7)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z",
    fill: "url(#N)",
    className: "B"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "O",
    cx: 671.8,
    cy: 96.14,
    r: 87.87,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.83 183.9l20.96-78.2 17.86 10.3z",
    fill: "url(#O)",
    className: "B"
  }), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 40,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 32,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 55c-22.1 0-40 17.9-40 40v1c0-22.1 17.9-40 40-40h88v-1H96z",
    className: "C E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 116c-6.92 11.94-19.8 20-34.6 20-14.8 0-27.7-8.06-34.6-20h-.04L8 24.48v1L61.4 117c6.92 11.94 19.8 20 34.6 20 14.8 0 27.68-8.05 34.6-20h.05v-1h-.06z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.1 0 40-17.9 40-40s-17.9-40-40-40z",
    opacity: 0.1,
    className: "C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 117.3c3.4-5.88 5.37-12.68 5.37-19.96a39.87 39.87 0 0 0-1.87-12.09c.95 3.42 1.5 7 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16L131 117.3z",
    fill: "#fff",
    className: "E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 9c48.43 0 87.72 39.13 88 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fill: "#fff",
    className: "E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 183c48.43 0 87.72-39.13 88-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 88 87.5z",
    className: "C D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.836ba41b2a8ade9da8bb9442b470e8e8.svg";
export { ForwardRef as ReactComponent };